export { KYC_LEVELS } from '@jagad/constants'

// Always English — sent to customer support, who only reads English.
export const INCREASE_LIMIT_SUPPORT_MESSAGE = 'Hi, I want to increase my limit.'
